import { IDestinationJobFilter } from '@principle-theorem/practice-migrations/interfaces';
import { isNil } from 'lodash';

export type DataResolverFn<JobData extends object> = (
  jobData: JobData
) => string | undefined;

export abstract class BaseDestinationJobFilterHandler<JobData extends object> {
  abstract key: string;
  abstract label: string;
  abstract description: string;

  constructor(private _dataResolverFn: DataResolverFn<JobData>) {}

  canHandle(filter: IDestinationJobFilter): boolean {
    return filter.key === this.key;
  }

  matches(jobData: JobData, filter: IDestinationJobFilter): boolean {
    if (isNil(filter.value)) {
      return false;
    }
    const data = this._dataResolverFn(jobData);
    return !isNil(data) && data === filter.value;
  }
}
